export const GET_REGISTRATIONS = "GET_REGISTRATIONS"
export const GET_REGISTRATIONS_FAIL = "GET_REGISTRATIONS_FAIL"
export const GET_REGISTRATIONS_SUCCESS = "GET_REGISTRATIONS_SUCCESS"

export const ADD_NEW_REGISTRATION = "ADD_NEW_REGISTRATION"
export const ADD_REGISTRATION_SUCCESS = "ADD_REGISTRATION_SUCCESS"
export const ADD_REGISTRATION_FAIL = "ADD_REGISTRATION_FAIL"

export const UPDATE_REGISTRATION = "UPDATE_REGISTRATION"
export const UPDATE_REGISTRATION_SUCCESS = "UPDATE_REGISTRATION_SUCCESS"
export const UPDATE_REGISTRATION_FAIL = "UPDATE_REGISTRATION_FAIL"

export const DELETE_REGISTRATION = "DELETE_REGISTRATION"
export const DELETE_REGISTRATION_SUCCESS = "DELETE_REGISTRATION_SUCCESS"
export const DELETE_REGISTRATION_FAIL = "DELETE_REGISTRATION_FAIL"





